var fundsOption = {
    title: {
        left: 'center',
        text: '',
    },
    animation: true,
    dataZoom: {
        show: false,
        realtime: false,
        start: 0,
        end: 100
    },
    tooltip: {
        trigger: 'axis',
        backgroundColor: "rgba(255,255,255,0.8)",
        borderWidth: "1",
        axisPointer: {
            type: 'cross'
        },
        borderColor: "#aaa",
        textStyle: {
            color: "#666"
        },
    },
    legend: {
        top: 22,
        data: [],
        width: 'auto',
        itemGap: 30,
        textStyle: {
            color: '#666'
        }
    },
    toolbox: {
        show: false,
        feature: {
            mark: { show: false },
            dataView: { show: true, readOnly: false },
            magicType: ['line', 'bar'],
            restore: { show: true },
            saveAsImage: { show: true }
        }
    },
    calculable: true,
    
    xAxis: [{
        type: 'category',
        boundaryGap: false,
        nameTextStyle: {
            color: '#666'
        },
        axisLine: {
            show: true,
            onZero: false,
            lineStyle: {
                color: '666'
            }
        },
        axisLabel: {
            textStyle: {
                color: "#666"
            }
        },
        data: [],
        name: ''
    }],

    yAxis: [{
        type: 'value',
        nameTextStyle: {
            color: '#666'
        },
        axisLabel: {
            textStyle: {
                color: "#666"
            }
        },
        splitArea: {
            show: true,
            interval: '1'
        },
        /**
        axisPointer: {
            snap: true
        },
        */
        name: ''
    }],

    series: []
};

export { fundsOption }